import { applyMiddleware, compose } from "redux"
import thunk from "redux-thunk";
import * as api from 'api-sdk'

// ----------------------------------
// Create with logger in dev mode
// ----------------------------------
export default function middleware() {
  // Develop with Chrome logging
  if ( process.env.NODE_ENV == "develop" ) {
    const enhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    return enhancers( applyMiddleware( thunk.withExtraArgument( api ) ) )
  }
  // Production
  return applyMiddleware( thunk.withExtraArgument( api ) )
}